import React from 'react';
import BaseSelectGroupsPage from '../Shared/BaseSelectGroupsPage';
import useAdditionalWorkflowLaunchNavigator from './additionalWorkflowLaunchNavigator';
import AdditionalWorkflowSteps, { AdditionalWorkflowStepId } from './AdditionalWorkflowSteps';
import { useConflictsContext } from './AdditionalWorkflowLaunchWrapper';
import { useProjectContext } from '../../view/ProjectContext';

export default function AdditionalWorkflowSelectGroupsPage() {
  const navigator = useAdditionalWorkflowLaunchNavigator();
  const conflictsContext = useConflictsContext();
  const projectContext = useProjectContext();

  if (!projectContext.plan) {
    return null;
  }

  return (
    <BaseSelectGroupsPage
      onNextClicked={navigator.openKeyDateTasksPage}
      onPrevClicked={navigator.isAiFlow ? navigator.openVerifyDataPage : undefined}
      planId={projectContext.plan.id}
      roadmap={(
        <AdditionalWorkflowSteps
          currentStep={AdditionalWorkflowStepId.GROUPS}
          hasConflicts={conflictsContext.hasConflicts}
          hasGroups={projectContext.plan.hasGroups}
        />
      )}
    />
  );
}
